let $ = jQuery;
let Hammer = require('hammerjs');
let breakpoints = require('../utilities/breakpoints');
// Import Greensock and it's plugins.
let CSSPlugin = require('../../node_modules/gsap/src/uncompressed/plugins/CSSPlugin');
let EasePack = require('../../node_modules/gsap/src/uncompressed/easing/EasePack');
let TweenLite = require('../../node_modules/gsap/src/uncompressed/TweenLite');

class RelatedPeople {

  constructor($relatedPeople) {
    this.$relatedPeople = $relatedPeople;
    this.$arrows = this.$relatedPeople.find('.pager__anchor--arrow');
    this.$dots = this.$relatedPeople.find('.pager__anchor--dot');
    this.$wrapper = this.$relatedPeople.find('.related-people__body');
    this.$content = this.$wrapper.find('.related-people__items');
    this.$items = this.$content.find('.related-people__item');
    this.currIndex = this.findCurrent().data('index');
    this.totalItems = this.$relatedPeople.find('.related-people__item').length;

    this.bindEvents();
  }

  bindEvents() {
    // Swipe Events.
    let wrapper = this.$wrapper[0];
    let hammer = new Hammer(wrapper);
    hammer.on('swipeleft', (e) => this.handleSwipeLeft(e));
    hammer.on('swiperight', (e) => this.handleSwipeRight(e));

    // Click Events.
    this.$dots.bind('click', (e) => this.handleDotClick(e));
    this.$arrows.bind('click', (e) => this.handleArrowClick(e));
  }

  handleDotClick(e) {
    let $target = $(e.target);
    this.currIndex = $target.data('index');

    this.updateView();
  }

  handleArrowClick(e) {
    let $target = $(e.target);
    let direction = $(e.target).data('direction');

    if (direction === 'previous' && this.currIndex > 0) {
      this.$dots.eq(this.currIndex - 1).trigger('click');
    }
    else if (direction === 'next' && this.currIndex < this.totalItems -1) {
      this.$dots.eq(this.currIndex + 1).trigger('click');
    }
  }

  handleSwipeRight(e) {
    if (breakpoints.current !== 'xlarge' && this.currIndex > 0) {
      this.$dots.eq(this.currIndex - 1).trigger('click');
    }
  }

  handleSwipeLeft(e) {
    if (breakpoints.current !== 'xlarge' && this.currIndex < this.totalItems - 1) {
      this.$dots.eq(this.currIndex + 1).trigger('click');
    }
  }

  findCurrent() {
    return this.$relatedPeople.find('.pager__anchor.is-active');
  }

  updateView() {
    this.updateDots();
    this.updateItemsPos();
  }

  updateDots() {
    this.$dots.removeClass('is-active');
    this.$dots.eq(this.currIndex).addClass('is-active');
  }

  updateItemsPos() {
    let $prevItems = this.$items.eq(this.currIndex).prevAll();
    let offset = 0;

    $prevItems.each(function(index) {
      offset += parseInt($(this).width());
      offset += parseInt($(this).css('margin-left'));
      offset += parseInt($(this).css('margin-right'));
    });

    window.TweenLite.to(this.$content, .25, {'transform': 'translateX(-' + offset + 'px' + ')'});
  }
}

module.exports = {
  attach: function(context, settings) {

    let $relatedPeople = $('.related-people');

    if ($relatedPeople.length > 0) {
      let relatedPeople = new RelatedPeople($relatedPeople);
    }
  }
};
